module.exports = __webpack_public_path__ + "media/images/ui__textArrowDown--dark-b22131ac387735b230d8b93e1d04dfc7.png";